import { Inject, Injectable } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { environment } from '@env';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { selectUser } from '@core/modules/user/features/user.slice';
import { Store } from '@ngrx/store';
import { AppConfig, APP_CONFIG } from 'app/app.config';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FirebaseAnalyticsService {
  constructor(private store: Store, @Inject(APP_CONFIG) private appConfig: AppConfig) {
    if (!environment.enabledAnalytic) return;

    FirebaseAnalytics.initializeFirebase({
      apiKey: this.appConfig.FIREBASE.API_KEY,
      authDomain: this.appConfig.FIREBASE.AUTH_DOMAIN,
      projectId: this.appConfig.FIREBASE.PROJECT_ID,
      storageBucket: this.appConfig.FIREBASE.STORAGE_BUCKET,
      messagingSenderId: this.appConfig.FIREBASE.MESSAGING_SENDER_ID,
      appId: this.appConfig.FIREBASE.APP_ID,
      measurementId: this.appConfig.FIREBASE.MEASUREMENT_ID
    });
  }

  pageEntered(event: NavigationEnd): void {
    if (!environment.enabledAnalytic) return;

    this.logEvent('pageEntered', { screenName: this.getScreenName(event) });
    this.store
      .select(selectUser)
      .pipe(first())
      .subscribe((user) => this.setUserId(user?.id.toString() || ''));
  }

  logEvent(
    eventName: string,
    params: { [key: string]: string | { [key: string]: string }[] }
  ): void {
    if (!environment.enabledAnalytic) return;

    FirebaseAnalytics.logEvent({ name: eventName, params }).catch(() => {});
  }

  setUserId(userId: string): void {
    if (!environment.enabledAnalytic) return;

    FirebaseAnalytics.setUserId({ userId }).catch(() => {});
  }

  private getScreenName(event: NavigationEnd): string {
    return event.url
      .split('/')
      .filter((item) => !!item)
      .join('-');
  }
}
